import {
    isFailure,
    parseAndMigratePerseusArticle,
    parseAndMigratePerseusItem,
    type PerseusItem,
    type PerseusRenderer,
} from "@khanacademy/perseus-core";
import Log, {Errors} from "@khan/logging";

/**
 * Parses a PerseusItem from JSON. If the JSON conforms to a known PerseusItem
 * format, it is migrated to the latest version. Otherwise, the parsed
 * (possibly invalid) object is returned anyway.
 *
 * @param json the JSON document to parse
 */
export function parsePerseusItem(json: string): PerseusItem {
    const result = parseAndMigratePerseusItem(json);

    if (isFailure(result)) {
        logFailure(result.detail.message, json);
        return result.detail.invalidObject as any;
    }

    return result.value;
}

/**
 * Parses a PerseusArticle from JSON. If the JSON conforms to a known article
 * format, it is migrated to the latest version. Otherwise, the parsed
 * (possibly invalid) object is returned anyway.
 *
 * @param json the JSON document to parse
 */
export function parsePerseusArticle(json: string): PerseusRenderer[] {
    const result = parseAndMigratePerseusArticle(json);

    if (isFailure(result)) {
        logFailure(result.detail.message, json);
        return result.detail.invalidObject as any;
    }

    return [result.value].flat();
}

function logFailure(message: string, json: string) {
    Log.error(`Perseus parser: ${message}`, Errors.Internal, {
        sentryData: {
            contexts: {
                perseus: {
                    json,
                },
            },
        },
    });
}
